import { hasError } from './state.utils';
export const buildAriaDescribedBy = ({ ariaDescribedBy, helpMessage, helpMessageId, errorMessage, errorMessageId, state, }) => {
    if (!ariaDescribedBy && !errorMessage && !helpMessage)
        return;
    let res = '';
    if (ariaDescribedBy) {
        res += ` ${ariaDescribedBy}`;
    }
    if (errorMessageId && errorMessage && hasError(state)) {
        res += ` ${errorMessageId}`;
    }
    if (helpMessageId && helpMessage) {
        res += ` ${helpMessageId}`;
    }
    return res;
};
//# sourceMappingURL=aria.utils.js.map